"use client"
import { Team } from "@/sources/kicker-amateur/types";
import { useState } from "react";
import Button from "@/app/pwa/components/Button";
import { Match } from "@/sources/kicker-amateur/types";
import { ModalTitle } from "@/app/pwa/components/Modal";
import Modal from "@/app/pwa/components/Modal";
import Share from "@/assets/icon/share.svg";
import MatchPosterSVG from "@/app/pwa/components/MatchPosterSVG";

export default function ShareMatchButton({match, team}: {match: Match, team: Team}) {
  const [isModalOpen, setModalOpen] = useState(false);
  function handleCloseModal() {
    setModalOpen(false);
  }
  return (  
    <>  
    <Button color="link-dark" className="mobile-nav-button -mr-4 lg:-mr-2" onClick={() => setModalOpen(true)}>
      <Share />
    </Button>
    
    {isModalOpen && (
    <Modal isOpen={isModalOpen} onRequestClose={handleCloseModal} title={`Teilen`} className="w-full max-w-xl">

    <ModalTitle>Spielgrafik</ModalTitle>
    <div className="text-center">
      Ideal zum einfachen Teilen auf deinen Social-Media-Kanälen.
    </div>
    <div className="mt-4">
      <MatchPosterSVG
        team={team}
        match={match}
      />
    </div>
  </Modal>
  )}
  </>
  )
}